define([
    'jquery',
    'web/jquery.triggerOnView',
    'web/jquery.pagination',
    /*projectspecific,
    feelfreetochange*///'bootstrap/transition',
    //'bootstrap/collapse',
    //'web/pluginPattern',
    'web/jquery.gm',
    'web/jquery.webslider',
    'web/jquery.dhtmlnumber',
    'web/jquery.cookie',
    'web/jquery.lightShop',
    'ramjet/new/jquery.liveValidation',
    'ramjet/new/jquery.partialUpdate'
], function($, web) {

    $('body').lightShop({
        data: window.web.products,
        categories: window.web.categories,
        orderFormUrl: window.web.orderFormUrl
    });

    /* zabalení a rozbalení mapy na stránce zastoupení */
    $(function(){
        $(document).on('click', '.map-toggle', function() {
            var openText = $(this).attr('data-open');
            var closeText = $(this).attr('data-close');
            $('body').toggleClass('gmap-minimized');
            if ($('body').hasClass('gmap-minimized')) {
                $('span', this).text(openText);
            } else {
                $('span', this).text(closeText);
            }
        });
    });

    /**
     * Get Array.max value
     */
    Array.max = function( array ){
        return Math.max.apply( Math, array );
    };

    var marksArr = new Array();

    /* funkčnost vlastního submenu v sekci Ultralehká letadla */
    //$(function(){
        $(window).bind('load resize', function() {

            if ($('.page-with-included-airplane-subpages').length > 0) {
                $('.page-with-included-airplane-subpages').each( function() {
                    var pageOffset;
                    marksArr = [];
                    $('.show-in-airplane-menu').each(function() {
                        pageOffset = $(this).offset().top - $('.airplane-submenu').outerHeight(false);
                        marksArr.push(pageOffset);
                    });
                });

                $(window).scroll(function(){
                    if ($(window).scrollTop() > $('header').outerHeight(false)) {
                        $('body').addClass('scrolled');

                        $($('.airplane-submenu li a').get().reverse()).each(function() {
                            var index = $(this).parent().index();
                            var offset = $(this).parents('.airplane-submenu').offset().top;
                            var scroll = marksArr[index];
                            if ( offset > scroll ) {
                                $('.airplane-submenu li').removeClass('active');
                                $('.airplane-submenu li:eq(' + index + ')').addClass('active');
                                return false;
                            }
                        });
                    } else {
                        $('body').removeClass('scrolled');
                    }
                });

                $(document).on('click', '.airplane-submenu li.scrolling-menu-item a, .airplane-image-navigation li a', function(event) {
                    event.preventDefault();
                    var index = $(this).parent().index();
                    if ($(this).parents().hasClass('airplane-image-navigation')) {
                        index++;
                    }
                    var scroll = marksArr[index] + 1;
                    $('body,html').animate({
                        scrollTop: scroll
                    }, 500);
                });
            }

            if ($(window).width() < 993) {
                $(document).on('click', '.lang-switch-arrow-closed .lang-switch-arrow',function(event) {
                    event.preventDefault();
                    $('body').addClass('lang-switch-focused');
                    $(this).parents('.lang-switch-cnt').removeClass('lang-switch-arrow-closed').addClass('lang-switch-arrow-open');
                });
                $('.lang-switch-arrow-closed #lang-switch li.active a').bind('click', function(event) {
                    event.preventDefault();
                    $('body').addClass('lang-switch-focused');
                    $(this).parents('.lang-switch-cnt').removeClass('lang-switch-arrow-closed').addClass('lang-switch-arrow-open');
                });
                $(document).on('click', '.lang-switch-arrow-open .lang-switch-arrow',function(event) {
                    event.preventDefault();
                    $('body').removeClass('lang-switch-focused');
                    $(this).parents('.lang-switch-cnt').removeClass('lang-switch-arrow-open').addClass('lang-switch-arrow-closed');
                });
                $('.lang-switch-arrow-open #lang-switch li.active a').bind('click', function(event) {
                    event.preventDefault();
                    $('body').removeClass('lang-switch-focused');
                    $(this).parents('.lang-switch-cnt').removeClass('lang-switch-arrow-open').addClass('lang-switch-arrow-closed');
                });
            } else {
                $('#lang-switch li.active a').unbind('click');
            }

        });
    //});

    /* funkčnost přepínače tabů */
    $(function(){
        $(document).on('click', '.tabs-list > li > a', function(e) {
            e.preventDefault();
            var index = $(this).parent().index();
            $('.tabs-list > li').removeClass('active');
            $(this).parent().addClass('active');

            $('.tabs-content-list > li').removeClass('active');
            $('.tabs-content-list > li:eq(' + index + ')').addClass('active');
        });
    });

    /* fulltext search input se zvětší na focus a zmenší na blur */
    $(function(){
        $(document).on('click', '.fulltextSwitch',function() {
            $('body').toggleClass('search-focused');
            $('body').removeClass('lang-switch-focused');
            $('.lang-switch-cnt').removeClass('lang-switch-arrow-open').addClass('lang-switch-arrow-closed');
        });
        /*$(document).on('blur', '.form-header-search input[type=text]',function() {
            $('body').removeClass('search-focused');
        });*/
    });

    /* fulltext - highlight hledaného výrazu */
    $(function(){
        $('#result').each(function() {
            var searchedQuery = $('.highlighted-text').text();
            $('#result li').each(function() {
                var textH2 = $('h2 a', this).text();
                var textP = $('p', this).text();
                var newTextH2 = textH2.replace(new RegExp(searchedQuery,"gi"), '<span class="searched-term">$&</span>');
                $('h2 a', this).html(newTextH2);
                var newTextP = textP.replace(new RegExp(searchedQuery,"gi"), '<span class="searched-term">$&</span>');
                $('p', this).html(newTextP);
            });
        });
    });

    /* přepínání jazyků */
    $(function(){

    });

    /* výška levého sloupce stejná jako pravého - hp dole */
    $(function(){
        var bottomContentArr = new Array();
        $('.hp-bottom-content .row > div').each(function() {
            var height = $(this).height();
            bottomContentArr.push(height);
        });
        if ( bottomContentArr[0] < bottomContentArr[1] ) {
            $('.hp-bottom-left-content').css({'height': bottomContentArr[1] + 'px'});
        }
    });

    $(function() {
        $('.same-columns-height').each(function() {
            var child = $(this).attr('data-child') || '*';
            $('>' + child, this).removeAttr('style');
            var colHeight = new Array();
            $('>' + child, this).each(function() {
                colHeight.push($(this).outerHeight(false));
            });
            var max = Array.max(colHeight);
            $('>' + child, this).css({'min-height' : max + 'px'});
        });
    });

    /* menu v rwd */
    $(function(){
        $(document).on('click', '.navbar-toggle',function() {
            $('.navbar-collapse, .top-menu-cnt, .navbar-toggle').toggleClass('in');
            //$('.lang-switch-cnt').toggleClass('lang-switch-arrow-open');
        });


        /* skrytí nadpisu iframu po hoveru */
        $(document).on('mouseover', '.hp-bottom-content iframe', function() {
            $('.hp-bottom-right-content article h2').fadeOut();
        });

        $(document).on('click', '.contact-anchor', function() {
            window.location = $('a', this).attr('href');
        });

        $(document).on('mouseenter', '.interactive-point', function() {
            $(this).next('div').addClass('visible');
        });

        $(document).on('mouseleave', '.interactive-point', function() {
            $(this).next('div').removeClass('visible');
        });

        /* skrytí nadpisu iframu po hoveru */
        $(document).on('click', '.interactive-point', function() {
            $(this).next('div').toggleClass('visible');
        });

        /* doplnění lokalizovaných textů v souborech ke stažení */
        var lang = $('html').attr('lang');
        $('.with-localized-text').each(function() {
            var langLabel = $(this).attr('data-label-' + lang);
            if (!(typeof langLabel === 'undefined')) {
                $(this).text(langLabel);
            }
        });

        $(document).on('click', '.cartIcon', function() {
            var cartOffset = $('#basket-list').offset().top;
            $('body, html').animate({
                scrollTop: cartOffset
            }, 500);
        });

    });

    $(function() {
        //dhtmlnumber pro zvysovani a snizovani hodnoty inputu
        $('.eshopToolBox input[type="text"]').dhtmlNumber();
    });

    $(function() {
        if ( $(window).width() > 1160 ) {
            $(window).on('scroll', function() {
                if ($('body').hasClass('eshop')) {
                    var windowHeight = $(window).height();
                    var basketOffset = $('#basket-list').offset().top - windowHeight;
                    if ($(window).scrollTop() > basketOffset) {
                        $('.cartIcon').fadeOut(100);
                    } else {
                        $('.cartIcon').fadeIn();
                    }
                }
            });
        }
    });

    $(window).on('load resize', function() {
        if ( $(window).width() > 1160 ) {
            $('.cartIcon').show();
        } else {
            $('.cartIcon').hide();
        }
    });

    /*
     * !!!NECHAT NA KONCI web.js!!!
     * V hlavičce webu je JavaScript var q = []; $ = function(f) {q.push(f)};, který zajistí,
     * že kdekoli vyskytující se inline javascript bude vykonán až po načtení stránky
     * Inline JavaScript musí být vnořen do následujícího kusu kódu
     *
     * $(function(){
     *     //inline JavaScript
     * });
     *
     * který je ve skutečnosti zkrácené volání $(document).ready() @see http://learn.jquery.com/using-jquery-core/document-ready/
     * předpokládá se tedy, že na webu bude použito jQuery
     *
     * viz http://www.slideshare.net/slideshow/embed_code/17116700?startSlide=10
     * */
    $.each(q, function(index, f) {
        $(f);
    });

});



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web.js